import { render, staticRenderFns } from "./CustomerServiceVerifyDialog.vue?vue&type=template&id=6c8cdef4"
import script from "./CustomerServiceVerifyDialog.vue?vue&type=script&lang=js"
export * from "./CustomerServiceVerifyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports